module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('h4', [_vm._v("Loading Data...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('accountgroupdialog', {
    ref: "dialog"
  })], 1), _vm._v(" "), _c('accountHeadList', {
    ref: "deleteData",
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-account": _vm.editAccount,
      "loading-started": function($event) {
        _vm.loading = true
      },
      "loading-finished": function($event) {
        _vm.loading = false
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff89904"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/AccountGroup.vue
// module id = 2046
// module chunks = 0